// src/api/axiosClient.js
import axios from 'axios';
import { API_BASE_URL } from '../config';

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- INTERCEPTOR 1: Request (Attach Token) ---
axiosClient.interceptors.request.use(
  (config) => {
    // Priority: Admin Token, then standard Token
    const token = localStorage.getItem('admin_token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- INTERCEPTOR 2: Response (Handle Errors) ---
axiosClient.interceptors.response.use(
  (response) => response.data, // Return only data, cleaner code
  (error) => {
    const { response } = error;
    
    // Security: If 401 (Unauthorized), Force Logout
    if (response && response.status === 401) {
      localStorage.removeItem('admin_token');
      // Optional: Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    // Return a standardized error object
    const errorMessage = response?.data?.detail || response?.data?.message || "An unexpected error occurred";
    return Promise.reject({ ...error, message: errorMessage });
  }
);

export default axiosClient;